import { SINGLE_CHOICE, MULTI_CHOICE, MATCH_OPTIONS } from '../enum/QuestionTypes';
class FlashcardQuestionConfigClass{
  constructor(config={}){
    config = config || {}; //handle case where config is null
    this.isMandatory = config.isMandatory || false;
    this.correctOption = config.correctOption || "";
    this.score = config.score || 0;
    this.negativeScore = config.negativeScore || 0;
    this.duration = config.duration || 0; //in seconds
    this.type = config.type || SINGLE_CHOICE;
    
    //private property
    this.__multiOptions = [];
    if(this.type === MULTI_CHOICE){
        this.__multiOptions = JSON.parse(this.correctOption || "[]");
    }else if(this.type === SINGLE_CHOICE){
        this.__multiOptions = [this.correctOption];
    }
    this.explanation = config.explanation || '';
    this.reattemptCount = config.reattemptCount || 0;
  }
  getIsMandatory(){
    return this.isMandatory;
  }
  getScore(){
    return this.score;
  }
  getNegativeScore(){
      return this.negativeScore;
  }
  isCorrect = (options) => {
      if(this.getIsMatchOptions()){
          return options.filter(pageItems => {
              let matchedGroups = pageItems.reduce((groupMap, pageItem) => {
                  groupMap[pageItem.itemContent.group] = '';
                  return groupMap;
              }, {});
              return Object.keys(matchedGroups).length !== 1 || pageItems.length <= 1;
          }).length === 0;
      }else{
          return this.getCorrectOption().filter(opt => options.indexOf(opt) === -1).length === 0 
          && (this.getCorrectOption().length === options.length);
      }
  }
  getCorrectOption(){
    return this.__multiOptions;
  }
  getDuration = () => {
    return this.duration;
  }
  computeScore = (selectedOptions) => {
    if(this.isCorrect(selectedOptions)){
        return this.score;
    }else{
        return this.negativeScore;
    }
  }
  isTimed(){
    return this.getDuration() > 0;
  }
  getIsMultiChoice(){
    return this.type === MULTI_CHOICE;
  }
  getIsMatchOptions(){
    return this.type === MATCH_OPTIONS;
  }
  getExplanation(){
    return this.explanation;
  }
  hasExplanation(){
    if(this.explanation && typeof this.explanation !== "undefined"){
        let content = this.explanation;
        let el = document.createElement('div');
        el.innerHTML = content;
        //below code is to remove line break &#8203; added by froala
        let text = el.innerText.trim().replace(/​/g, '');
        return text !== '';
    }
    return false;
  }
  getReattemptCount(){
    return this.reattemptCount;
  }
}

const FlashcardQuestionConfig = config => new FlashcardQuestionConfigClass(config);
export default FlashcardQuestionConfig;